import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import { routes } from "./routes";
import userContext from "src/context/userContext";
import shopContext from "src/context/shopContext";
import processingContext from "src/context/processingContext";
import { useEffect, useRef, useState } from "react";
import { get } from "./services/HttpClient";
import { getData } from "./actions/getData";
import 'react-loading-skeleton/dist/skeleton.css'


const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

function App() {

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/version.json", {
          cache: "no-store",
        });
        const data = await res.json();

        const currentVersion = data.version;
        const savedVersion = localStorage.getItem("app_version");

        if (!savedVersion) {
          // اولین بار
          localStorage.setItem("app_version", currentVersion);
        } else if (savedVersion !== currentVersion) {
          const confirmed = window.confirm("نسخه جدیدی از برنامه در دسترس است. آیا مایلید بروزرسانی انجام شود؟");
          if (confirmed) {
            localStorage.setItem("app_version", currentVersion);
            window.location.reload(true); // reload از سرور، نه کش
          }
        }
      } catch (err) {
        console.error("خطا در بررسی نسخه جدید:", err);
      }
    };

    checkVersion();
  }, []);



  const [user, setUser] = useState({});
  const [orders, setOrders] = useState();
  const [sales, setSales] = useState();
  const [products, setProducts] = useState();
  const [inconsistenceItems, setInconsistenceItems] = useState()
  const [processingOrders, setProcessingOrders] = useState()
  const [inboundProducts, setInboundProducts] = useState()

  // GET user FROM BACKEND
  const getUser = async () => {
    const result = await get("/users/auth");
    if (result) {
      setUser(result.data);
    }
  };



  const getShopData = async () => {
    getData(setProducts, "/products");
    getData(setSales, "/sales");
    getData(setOrders, "/orders");
    getData(setInconsistenceItems, "/sepidar/inconsistenceItems");
  }

  useEffect(() => {
    getUser();
    // getShopData();
  }, []);





  return (
    <processingContext.Provider value={{ processingOrders, setProcessingOrders, inboundProducts, setInboundProducts }}>
      <shopContext.Provider value={{ orders, setOrders, sales, setSales, products, setProducts, inconsistenceItems, setInconsistenceItems }}>
        <userContext.Provider value={{ user, setUser }}>
          <RouterProvider router={router} />
        </userContext.Provider>
      </shopContext.Provider>
    </processingContext.Provider>
  );
}

export default App;
